<div class="events-subsection">
    <ul class="filters-logbook-events-subsection">
        <li *ngFor="let event of events |  sortBy: 'title' : 'asc'" (click)="onSelect(event)" >
            <span class="filter-subtitle" [ngClass]="{longname:(event.title.length > 20)}">{{event.title}}</span>
        </li>
    </ul>
</div>
